import React from 'react'

type Props = {
    children: React.ReactNode
    className?: string
}

/**
 * Split background layout with a background image in the top half
 * and white in the bottom half. Content is positioned at the center
 * (halfway point) to overlap both sections.
 */
export const SplitBackgroundLayout = (props: Props) => {
    const { children, className = '' } = props

    return (
        <div className={`relative w-full ${className}`}>
            {/* Top half - background image */}
            <div className="absolute top-0 left-0 right-0 h-1/2 bg-[url('/public/header_tile_gold.png')] bg-tile" />

            {/* Bottom half - white background */}
            <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-white dark:bg-gray-900" />

            {/* Content container - positioned at center (halfway) */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full px-4">
                {children}
            </div>
        </div>
    )
}
